import { HttpClient, HttpBackend, HttpInterceptor } from '@angular/common/http';
import { ErmApiClientInterceptingHandler } from './erm-api-client.http-handler';
import { BaseUrlInterceptor } from './interceptors/base-url.interceptor';
import { LoggingInterceptor } from './interceptors/logging.interceptor';
import { AuthHeaderInterceptor } from './interceptors/auth-header.interceptor';
import { Injectable } from '@angular/core';
import { AcceptHeaderInterceptor } from './interceptors/accept-header.interceptor';

@Injectable()
export class ErmApiClientBuilderService {

  interceptors: HttpInterceptor[];

  constructor(private httpBackend: HttpBackend) {
    this.interceptors = new Array<HttpInterceptor>();
  }

  useBaseUrl(baseUrl?: string): ErmApiClientBuilderService {
    if (!baseUrl) {
      return this;
    }
    this.interceptors.push(new BaseUrlInterceptor(baseUrl));
    return this;
  }

  useLogging(useLogging: boolean = true): ErmApiClientBuilderService {
    if (!useLogging) {
      return this;
    }
    this.interceptors.push(new LoggingInterceptor());
    return this;
  }

  useAuthHeader(authHeaderResolver?: () => Promise<string>): ErmApiClientBuilderService {
    if (!authHeaderResolver) {
      return this;
    }
    this.interceptors.push(new AuthHeaderInterceptor(authHeaderResolver));
    return this;
  }

  acceptJson(): ErmApiClientBuilderService {
    this.interceptors.push(new AcceptHeaderInterceptor('application/json'));
    return this;
  }

  build(): HttpClient {
    return new HttpClient(new ErmApiClientInterceptingHandler(this.httpBackend, this.interceptors));
  }
}
